import { Observable, of, ReplaySubject } from 'rxjs';
import { FeatureFlagsRecord } from '../dto';

export class FeatureFlagsStorage {
  private readonly featureFlagsSubject: ReplaySubject<FeatureFlagsRecord> = new ReplaySubject<FeatureFlagsRecord>(1);

  flags$: Observable<FeatureFlagsRecord> = this.featureFlagsSubject.asObservable();

  setState(data: FeatureFlagsRecord): Observable<FeatureFlagsRecord> {
    this.featureFlagsSubject.next(data);
    return of(data);
  }
}
